/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuotingActivationStrategyType {
  UnderConstruction = "UnderConstruction",
  Testing = "Testing",
  Shadow = "Shadow",
  Benchmark = "Benchmark",
  Reference = "Reference",
  Paused = "Paused",
  Active = "Active",
  Deprecated = "Deprecated",
}

export function instanceOfQuotingActivationStrategyType(value: any): boolean {
  for (const key in QuotingActivationStrategyType) {
    if (
      Object.prototype.hasOwnProperty.call(QuotingActivationStrategyType, key)
    ) {
      if (
        QuotingActivationStrategyType[
          key as keyof typeof QuotingActivationStrategyType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuotingActivationStrategyTypeFromJSON(
  json: any,
): QuotingActivationStrategyType {
  return QuotingActivationStrategyTypeFromJSONTyped(json, false);
}

export function QuotingActivationStrategyTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuotingActivationStrategyType {
  return json as QuotingActivationStrategyType;
}

export function QuotingActivationStrategyTypeToJSON(
  value?: QuotingActivationStrategyType | null,
): any {
  return value as any;
}

export function QuotingActivationStrategyTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuotingActivationStrategyType {
  return value as QuotingActivationStrategyType;
}
